import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';

import { ResponsableTourismComponent } from './components/PE/responsable-tourism.component';
import { ResponsableTourismRoutingModule } from './responsable-tourism-routing.module';
import { ModalModule } from '@ux/components/modal/modal.module';
import { GlobalPipesModule } from '@app/pipes/global-pipes.module';

@NgModule({
  declarations: [ResponsableTourismComponent],
  imports: [
    CommonModule,
    ResponsableTourismRoutingModule,
    TranslocoModule,
    ModalModule,
    GlobalPipesModule,
  ]
})
export class ResponsableTourismModule { }
